export default "__VITE_ASSET__DHuaELx$__"